import { GridProps } from '@nautilusbio/nb-design-system/Grid';
import { StackProps } from '@nautilusbio/nb-design-system/Stack';

const gridProps: Omit<GridProps, 'children'> = {
  alignItems: 'start',
  columns: 2,
  fullWidth: true,
  gap: 8,
};

const stackProps: StackProps = {
  fullWidth: true,
  gap: 4,
};

export { gridProps, stackProps };
